import { Screen, EmptyCase } from '../../components';
import { useGetAllBranchForumQuestions } from '../../services/forumQuestion';
import { ForumQuestion } from './components/ForumQuestion';
import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { ForumQuestionModal } from './components/ForumQuestionModal';
import { Skeleton } from 'antd';
import clsx from 'clsx';

const ForumPage = () => {
  const { questions, loading, refetch } = useGetAllBranchForumQuestions();

  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal((prev) => !prev);
  };

  return (
    <Screen
      id="forum"
      title="Foro"
      actions={[{
        icon: (
          <IconPlus
            size={20}
            className="text-white"
            strokeWidth={2.5}
          />
        ),
        onClick: toggleModal
      }]}
    >
      {loading ? (
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className={clsx(
                'rounded-xl border p-6',
                'bg-white border-gray-200',
                'dark:bg-surface-dark dark:border-borders'
              )}
            >
              <Skeleton active paragraph={{ rows: 3 }} />
            </div>
          ))}
        </div>
      ) : questions && questions.length > 0 ? (
        <div className="space-y-4">
          {questions.map((question) => (
            <ForumQuestion key={question._id} question={question} refetch={refetch} />
          ))}
        </div>
      ) : (
        <EmptyCase text="No hay preguntas en el foro. ¡Sé el primero en crear una!" />
      )}
      {modal && (
        <ForumQuestionModal open={modal} onClose={toggleModal} refetch={refetch} />
      )}
    </Screen>
  );
};

export { ForumPage };
